import ICartResponse from 'network/response/ICart';
import { useEffect } from 'react';
import Tracker from 'utils/Tracker';
import Transform from 'utils/TransformData';
import { initStorageManager } from 'utils/customStorage.util';
import { COUNTRY_CODE_KEY } from 'pages/Cart/constants/cart.constants';
import { EShipmentTypes } from 'services/shipments/types/shipments.types';
import { getShipmentData } from 'utils/getSelectedAddress.util';
import useNewC4Journey from 'hooks/useNewC4Journey';
import { checkoutType } from 'pages/Cart/helpers/url.helpers';

const useCheckoutGTM = (cartData: ICartResponse) => {
  const { paymentMode, code } = cartData;
  const storage = initStorageManager(() => sessionStorage);
  const countryCode = storage.getItem(COUNTRY_CODE_KEY) || undefined;
  const { shipments } = cartData;
  const isCartEmpty = Object.keys(cartData).length === 0;
  const isNewJourney = useNewC4Journey();
  const shipmentType = checkoutType();

  useEffect(() => {
    // Track cart load
    if (!code) {
      return;
    }
    const eventData = {
      shipments_cnc: getShipmentData(shipments, EShipmentTypes.CNC),
      shipments_std_food: getShipmentData(shipments, EShipmentTypes.STANDARD_FOOD),
      shipments_std_nonfood: getShipmentData(shipments, EShipmentTypes.STANDARD_NONFOOD),
      shipments_mkt: getShipmentData(shipments, EShipmentTypes.MARKETPLACE),
      shipments_express: getShipmentData(shipments, EShipmentTypes.EXPRESS),
    };
    try {
      if (!isCartEmpty) {
        Tracker.gtmCheckoutPageLoad(
          {
            cartId: code,
            payment: paymentMode,
            products: Transform.productData(cartData, undefined, undefined, { ga4: false }),
            screenName: 'checkout',
            screenType: 'checkout',
          },
          false
        );
        Tracker.gtmCheckoutPageLoad(
          {
            cartId: code,
            payment: paymentMode,
            products: Transform.productData(cartData, undefined, undefined, {
              ga4: true,
              countryCode,
            }),
            screenName: 'checkout',
            screenType: 'checkout',
            isNewJourney,
            shipmentIdentifire: shipmentType,
            stepCount: 2,
          },
          true,
          eventData,
          (shipments && shipments.length) || 0
        );
      }
    } catch (error) {
      // Data error
      // tslint:disable: no-console
      console.error(error);
    }
  }, [
    code,
    paymentMode,
    cartData,
    countryCode,
    shipments,
    isCartEmpty,
    shipmentType,
    isNewJourney,
  ]);
};

export default useCheckoutGTM;
